import { render } from "./VisualEditsPanel.vue?vue&type=template&id=75700b2c&scoped=true"
import script from "./VisualEditsPanel.vue?vue&type=script&lang=js"
export * from "./VisualEditsPanel.vue?vue&type=script&lang=js"

import "./VisualEditsPanel.vue?vue&type=style&index=0&id=75700b2c&scoped=true&lang=css"
import "./VisualEditsPanel.vue?vue&type=style&index=1&id=75700b2c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75700b2c"]])

export default __exports__